export class CrossSectionModel {
    _id: string;
    name: string;
    description: string;
    system: string;
    picture: string;
    stepFile: string;
    duenqName: string;

    constructor(id = '',
        name = '',
        description = '',
        system = '',
        picture = '',
        stepFile = '',
        duenqName = '') {
            this._id = id;
            this.description = description;
            this.system = system;
            this.name = name;
            this.picture = '';
            this.stepFile = '';
            this.duenqName = duenqName;
    }
}
